<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom">
    <router-link to="/" class="navbar-brand" href="#">
      <img src="@/assets/logo.png" alt="Application icon" height="42">
    </router-link>
    <button class="navbar-toggler ml-auto"
      type="button"
      data-toggle="collapse"
      data-target="#navbar"
      aria-controls="navbar"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbar">
      <ul class="navbar-nav mr-auto mt-2 mt-lg-0 w-100">
        <li class="nav-item"
          v-for="(option, index) in menu"
          v-bind:key="index">
          <router-link class="nav-link"
            v-bind:to="option.path"
            v-bind:class="{ 'active font-weight-bold': $route.path.includes(option.path), }">
            {{option.label}}
          </router-link>
        </li>
        <li class="nav-item mr-auto mr-lg-0 ml-lg-auto">
          <div class="dropdown" v-if="authenticated">
            <a href="javascript:;"
              class="btn btn-block dropdown-toggle font-weight-bold authenticated"
              data-toggle="dropdown">
              Hola, {{name}}
            </a>
            <div class="dropdown-menu dropdown-menu-right">
              <a href="javascript:;"
                class="dropdown-item"
                v-on:click.prevent="signOut">
                Cerrar Sesión
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
  import menu from "@/menu";
  import { auth, } from "@/firebase";
  export default {
    data() {
      return {
        menu,
      };
    },
    computed: {
      name() {
        return this.$store.state.user && this.$store.state.user.name;
      },
      authenticated() {
        return !!this.$store.state.user;
      },
    },
    methods: {
      async signOut() {
        try {
          await auth.signOut();
          this.$router.replace("/login");
        } catch(e) {
          console.error(e);
          this.$swal("Oops!", "Ha ocurrido un error al cerrar la sesión. Intenta nuevamente.", "error");
        }
      },
    },
  };
</script>